import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as toContactDto } from '../../../models/adapters/ContactAdapter';
import { contactSaved, contactSaveFailed, saveContact, SaveContactActionType } from '../../actions/setting/saveContact';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* saveContactSaga({ payload }: SaveContactActionType) {
  const { contact } = payload;
  const token = yield getAuthenticationToken();
  const contactDto = toContactDto(contact);
  const timestamp = moment();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateContact, token, { contactDto });
  if (!response.error) {
    yield put(contactSaved({ contact, timestamp }));
  } else {
    yield put(contactSaveFailed({ placeUuid: contact.placeUuid, contactUuid: contact.uuid, timestamp }));
  }
}

export default function* watchSaveContactSaga() {
  yield takeEvery(saveContact, saveContactSaga);
}
